/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getBloodBankInventories } from 'app/entities/blood-bank-inventory/blood-bank-inventory.reducer';
import { getEntities as getBloodBanks } from 'app/entities/blood-bank/blood-bank.reducer';
import { createEntity, getEntity, reset, updateEntity } from './blood-bank-adverse-event.reducer';

export const BloodBankAdverseEventUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const bloodBankInventories = useAppSelector(state => state.bloodBankInventory.entities);
  const bloodBanks = useAppSelector(state => state.bloodBank.entities);
  const bloodBankAdverseEventEntity = useAppSelector(state => state.bloodBankAdverseEvent.entity);
  const loading = useAppSelector(state => state.bloodBankAdverseEvent.loading);
  const updating = useAppSelector(state => state.bloodBankAdverseEvent.updating);
  const updateSuccess = useAppSelector(state => state.bloodBankAdverseEvent.updateSuccess);

  const handleClose = () => {
    navigate(`/blood-bank-adverse-event${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getBloodBankInventories({}));
    dispatch(getBloodBanks({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.reactionDate !== undefined && typeof values.reactionDate !== 'number') {
      values.reactionDate = Number(values.reactionDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...bloodBankAdverseEventEntity,
      ...values,
      inventory: bloodBankInventories.find(it => it.id.toString() === values.inventory?.toString()),
      bank: bloodBanks.find(it => it.id.toString() === values.bank?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...bloodBankAdverseEventEntity,
          inventory: bloodBankAdverseEventEntity?.inventory?.id,
          bank: bloodBankAdverseEventEntity?.bank?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.bloodBankAdverseEvent.home.createOrEditLabel" data-cy="BloodBankAdverseEventCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.home.createOrEditLabel">
              Create or edit a BloodBankAdverseEvent
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="blood-bank-adverse-event-id"
                  label={translate('tinyMedicRestApp.bloodBankAdverseEvent.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankAdverseEvent.reactionDate')}
                id="blood-bank-adverse-event-reactionDate"
                name="reactionDate"
                data-cy="reactionDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankAdverseEvent.reactionType')}
                id="blood-bank-adverse-event-reactionType"
                name="reactionType"
                data-cy="reactionType"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankAdverseEvent.reactionDescription')}
                id="blood-bank-adverse-event-reactionDescription"
                name="reactionDescription"
                data-cy="reactionDescription"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankAdverseEvent.severity')}
                id="blood-bank-adverse-event-severity"
                name="severity"
                data-cy="severity"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankAdverseEvent.reportedTo')}
                id="blood-bank-adverse-event-reportedTo"
                name="reportedTo"
                data-cy="reportedTo"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankAdverseEvent.actionTaken')}
                id="blood-bank-adverse-event-actionTaken"
                name="actionTaken"
                data-cy="actionTaken"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankAdverseEvent.active')}
                id="blood-bank-adverse-event-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankAdverseEvent.cursor')}
                id="blood-bank-adverse-event-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankAdverseEvent.lastUpdated')}
                id="blood-bank-adverse-event-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankAdverseEvent.microSec')}
                id="blood-bank-adverse-event-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBankAdverseEvent.timestampEntry')}
                id="blood-bank-adverse-event-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="blood-bank-adverse-event-inventory"
                name="inventory"
                data-cy="inventory"
                label={translate('tinyMedicRestApp.bloodBankAdverseEvent.inventory')}
                type="select"
              >
                <option value="" key="0" />
                {bloodBankInventories
                  ? bloodBankInventories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-bank-adverse-event-bank"
                name="bank"
                data-cy="bank"
                label={translate('tinyMedicRestApp.bloodBankAdverseEvent.bank')}
                type="select"
              >
                <option value="" key="0" />
                {bloodBanks
                  ? bloodBanks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/blood-bank-adverse-event" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BloodBankAdverseEventUpdate;
